import { createFileRoute } from "@tanstack/react-router";
import SeoMetaGeneratorPage from "@/pages/SeoMetaGeneratorPage";

export const Route = createFileRoute("/tools/seo-meta-generator")({
  component: SeoMetaGeneratorPage,
});
